import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
var lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
var lazyQuickModule = new LazyModule(() => import('./lazyQuickOption'));
let DateHeadersOption: LazyOption = createLazyOption(
    {
        key: 'dateHeaders',
        titleStringKey: 'optionTitle_dateHeaders',
        searchTermsStringKey: 'optionTitle_dateHeaders',
    },
    lazyFullModule,
    m => m.default,
    lazyQuickModule,
    m => m.default
);
export default DateHeadersOption;
